module.exports = App.MapPopupMixin = Ember.Mixin.create
  tagName: 'div'
  layoutName: 'components/map-popup-mixin'
  popupOpen: false
  hasPopup: false

  destinationElement: Ember.computed(->
    document.createElement 'div'
  )

  popupOpenDidChange: Ember.observer('popupOpen', ->
    if @get('popupOpen')
      if !@_popup._isOpen
        @_layer.openPopup()
    else
      if @_popup._isOpen
        @_layer.closePopup()
    return
  )

  willInsertElement: ->
    @_super.apply this, arguments
    @_firstNode = @element.firstChild
    @_lastNode = @element.lastChild
    @appendToDestination()
    return

  appendToDestination: ->
    destinationElement = @get('destinationElement')
    @appendRange destinationElement, @_firstNode, @_lastNode
    return

  appendRange: (destinationElement, firstNode, lastNode) ->
    while firstNode
      destinationElement.insertBefore firstNode, null
      firstNode = if firstNode != lastNode then lastNode.parentNode.firstChild else null
    return

  didCreateLayer: ->
    @_super.apply @, arguments

    if @get 'hasPopup'
      @_popup = @L.popup({}, @_layer)
      @_popup.setContent @get('destinationElement')
      @_layer.bindPopup @_popup
      @_hijackPopup()
      @popupOpenDidChange()

    return

  _hijackPopup: ->
    oldOnAdd = @_popup.onAdd
    self = @

    @_popup.onAdd = (map) ->
      self.set 'popupOpen', true
      Ember.run.schedule 'render', ->
        oldOnAdd.call self._popup, map
        return
      return

    oldOnRemove = @_popup.onRemove

    @_popup.onRemove = (map) ->
      oldOnRemove.call self._popup, map
      self.set 'popupOpen', false
      return

    return

  willDestroyLayer: ->
    @_super.apply this, arguments
    if @get('hasPopup')
      @_layer.unbindPopup()
      delete @_popup
      delete @_firstNode
      delete @_lastNode
    return
